import { render, staticRenderFns } from "./ProjectContextModal.vue?vue&type=template&id=10188f5c"
import script from "./ProjectContextModal.vue?vue&type=script&lang=js"
export * from "./ProjectContextModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports